import type { ValidationIssue } from '@customerio/dryad';
import type { OptOutChannel } from './opt-out-channel';

/**
 * The editing state an opt-out leaf holds. Shared across surfaces; each one's
 * plugin owns how it encodes this on its own wire.
 */
export type OptOutConditionState = {
  channel: OptOutChannel;
  // '' is a legitimate value (the picker's "Any number"); null means nothing
  // has been picked yet, which blocks the commit.
  phoneNumber: string | null;
  negate: boolean;
};

/**
 * A null number only occurs while the number select is untouched; '' is
 * accepted as "Any number". Every surface's opt-out row validates the same way,
 * whatever its wire.
 */
export function validateOptOutCondition(state: OptOutConditionState): Required<ValidationIssue>[] {
  if (state.phoneNumber == null) {
    return [{ message: "Phone number can't be blank.", field: 'phoneNumber' }];
  }
  return [];
}

/** The negate select's wording, which reads differently per surface. */
export type OptOutNegateWording = {
  optedOut: string;
  notOptedOut: string;
};
